import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Typography } from 'antd';

export const FuturTerminationNotice = ({ visible, close }) => {
  return (
    <Modal
      title="Résiliation programmée"
      open={visible}
      onCancel={close}
      styles={{ body: { textAlign: 'center' } }}
      footer={false}
      centered
    >
      <Typography.Text>
        {`Une résiliation est programmée sur ce contrat, vous pouvez contacter ASSURMAX au `}
        <a style={{ display: 'inline' }} href="tel:0328649623">
          03 28 64 96 23
        </a>
        {` ou sur `}
        <a
          style={{ display: 'inline' }}
          href="mailto:courtiers@assurmaxpro.com"
        >
          courtiers@assurmaxpro.com
        </a>
      </Typography.Text>
    </Modal>
  );
};

FuturTerminationNotice.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};
